import * as React from "react";

import Background from '../assets/images/bg-auth.jpg';
import { makeStyles, Theme } from "@material-ui/core/styles";
import LogoBig from "./LogoBig";
import { Hidden } from "@material-ui/core";
import LogoSmall from "./LogoSmall";

const useStyles = makeStyles((theme: Theme) => ({
	right: {
    width: '66%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
		backgroundColor: "#000",
		backgroundImage: `url(${Background})`,
    backgroundSize: "cover",
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      alignItems: 'stretch',
      flex: '1 1 auto'
    }
  },
  left: {
    width: '34%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#1C1A19',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: '52px 0 24px'
    }
  },
	container: {
    display: 'flex',
    height: '100vh',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  },
  hiddenUpXs: {
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  }
}));

const AuthWrapper: React.FC = ({ children }) => {
	const classes = useStyles();
	return (
    <div className={classes.container}>
      <div className={classes.left}>
        <Hidden only='xs'>
          <LogoBig />
        </Hidden>
        <div className={classes.hiddenUpXs}>
          <LogoSmall />
        </div>
      </div>
      <div className={classes.right}>
        {children}
      </div>
    </div>
	);
};

export default AuthWrapper;
